<template>
  <div>
    <!--<v-card>-->
    <v-subheader>违章详细信息</v-subheader>
    <v-layout key="info1" row wrap>
      <v-flex xs12>
        <v-container grid-list-md>
          <v-layout row wrap xs8>
            <v-flex class="grey--text" xs4 md2>
              车辆号牌：
            </v-flex>
            <v-flex xs8 md4>
              {{event.plate}}
            </v-flex>
            <v-flex class="grey--text" xs4 md2>
              车主姓名：
            </v-flex>
            <v-flex xs8 md4>
              {{event.vehicle.name}}
            </v-flex>
            <v-flex class="grey--text" xs4 md2>
              登记类型：
            </v-flex>
            <v-flex xs8 md4>
              {{event.vehicle.typeName}}
            </v-flex>
            <v-flex class="grey--text" xs4 md2>
              联系方式：
            </v-flex>
            <v-flex xs8 md4>
              {{event.vehicle.phone}}
            </v-flex>
            <v-flex class="grey--text" xs4 md2>
              用户单位：
            </v-flex>
            <v-flex xs8 md4>
              {{event.vehicle.orgName}}
            </v-flex>
            <v-flex class="grey--text" xs4 md2>
              违章区域：
            </v-flex>
            <v-flex xs8 md4>
              {{event.area}}
            </v-flex>
            <!--<v-flex class="grey&#45;&#45;text" xs4 md2>-->
            <!--违章大类：-->
            <!--</v-flex>-->
            <!--<v-flex xs8 md4>-->
            <!--{{event.violationRule.name}}-->
            <!--</v-flex>-->
            <v-flex class="grey--text" xs4 md2>
              违章类型：
            </v-flex>
            <v-flex xs8 md4>
              {{event.typeName}}
            </v-flex>
            <v-flex class="grey--text text-truncate" xs4 md2>
              违章上报时间：
            </v-flex>
            <v-flex xs8 md4>
              {{this.$L.time.stringify(event.results[VIOLATION_ROLE.TRAFFIC_ADMIN].creationTime)}}
            </v-flex>
            <v-flex class="grey--text text-truncate" xs4 md2>
              初步处理时间：
            </v-flex>
            <v-flex xs8 md4>
              {{this.$L.time.stringify(event.results[VIOLATION_ROLE.ALARM_ADMIN].creationTime)}}
            </v-flex>
            <v-flex class="grey--text text-truncate" xs4 md2>
              最终处理时间：
            </v-flex>
            <v-flex xs8 md4>
              {{this.$L.time.stringify(event.results[VIOLATION_ROLE.VIOLATION_ADMIN].creationTime)}}
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-subheader>违章取证图片</v-subheader>
    <v-layout class="px-3 pb-3" wrap>
      <v-flex>
        <l-image v-if="event.imageList.length === 0"></l-image>
        <l-image-dialog
          :src="img.src"
          v-for="(img,i) in event.imageList" :key="i">
          <l-image
            slot="activator"
            :src="img.src"
            :loading="img.loading"
            :error="img.error"
            :errorMessage="img.errorMessage"
          ></l-image>
        </l-image-dialog>
      </v-flex>
    </v-layout>
    <v-expand-transition>
      <v-container v-if="expand" key="info2" grid-list-md class="py-0">
        <v-layout row wrap>
          <v-flex class="grey--text text-truncate" xs3 md2>
            交通管理员描述：
          </v-flex>
          <v-flex xs9 md10>
            {{event.results[VIOLATION_ROLE.TRAFFIC_ADMIN].comment}}
          </v-flex>
          <v-flex class="grey--text text-truncate" xs3 md2>
            交通管理员语音：
          </v-flex>
          <v-flex xs9 md10>
            <!--<v-icon>volume_up</v-icon>-->
          </v-flex>
          <v-flex class="grey--text text-truncate" xs3 md2>
            报警中心附言：
          </v-flex>
          <v-flex xs9 md10>
            {{event.results[VIOLATION_ROLE.ALARM_ADMIN].comment}}
          </v-flex>
          <v-flex class="grey--text text-truncate" xs3 md2>
            违章管理员附言：
          </v-flex>
          <v-flex xs9 md10>
            {{event.results[VIOLATION_ROLE.VIOLATION_ADMIN].comment}}
          </v-flex>
        </v-layout>
      </v-container>
    </v-expand-transition>
    <v-layout key="action">
      <v-flex @click="expand = !expand" class="pb-3" layout justify-center align-center>
        <span style="cursor: pointer" class="primary--text">{{expand?'收起详细描述':'展开详细描述'}}</span>
        <v-icon color="primary" @click="expand = !expand"  class="pl-2" clickable small>{{expand ? 'mdi-chevron-up':'mdi-chevron-down'}}</v-icon>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import {VIOLATION_ROLE} from '../../../object'

export default {
  name: 'violationInfo',
  props: {
    open: {type: Boolean, default: false},
    event: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    VIOLATION_ROLE,
    viewImage: false,
    expand: false
  }),
  computed: {
  },
  created () {
    if (this.open) {
      this.expand = true
    }
  }
}
</script>
